import { render, staticRenderFns } from "./VLabel.vue?vue&type=template&id=04cd2751&scoped=true&functional=true"
import script from "./VLabel.vue?vue&type=script&lang=js"
export * from "./VLabel.vue?vue&type=script&lang=js"
import style0 from "./VLabel.vue?vue&type=style&index=0&id=04cd2751&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "04cd2751",
  null
  
)

export default component.exports